import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsDoneWorks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORKS,
	},
	getReportsDoneWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK,
	},
  getReportsDoneWorkPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK_PREVIEW,
	},
}